<form [formGroup]="form">
  <div class="row">
    <!-- Name -->
    <div class="col-sm-12">
      <mat-form-field2 class="mat-block" matTooltip="Enter a unique name for your channel." i18n-matTooltip>
        <input
          type="text"
          matInput
          required
          i18n-placeholder
          placeholder="Channel Name"
          formControlName="friendly_name"
          maxlength="50"
        />
        <mat-error i18n *ngIf="form.get('friendly_name').touched && form.get('friendly_name').hasError('required')">
          Name is required
        </mat-error>
        <mat-hint align="end">{{ form.get('friendly_name').value.length || 0 }}/50</mat-hint>
      </mat-form-field2>
    </div>

    <div class="col-sm-12">
      <mat-form-field2 class="mat-block">
        <textarea matInput placeholder="Description" i18n-placeholder formControlName="description"></textarea>
      </mat-form-field2>
    </div>
    <div class="col-sm-12" *ngIf="!!form.get('logo').value">
      <img [src]="form.get('logo').value" alt="LOGO" style="height: 50px" class="border" />
    </div>
    <div class="col-sm-12 mt-3">
      <button (click)="onUpload()" type="button" class="btn btn-secondary-primary create-btn">
        <i class="far fa-image"></i> <ng-container i18n>Upload Logo</ng-container>
      </button>
    </div>
  </div>
</form>
